import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import Header from '../../componets/header';
import HeaderMobile from '../../componets/header/mobile';
import HomeInternal from '../../blocks/home/internal';
import PageInternalRad from '../../blocks/page/rad';
import HomeMobile from '../../blocks/home/mobile';
import Footer from '../../componets/footer';


class Rad extends Component {
    renderContent = () => {
        if (isMobile) {
            return (
                <main>
                    <HeaderMobile/>
                    <HomeInternal logo="rad"/>
                    <PageInternalRad/>
                    <Footer/>
                </main>
            )
        }
        return (
            <main>
                <Header/>
                <HomeInternal logo="rad"/>
                <PageInternalRad/>
                <Footer/>
            </main>
        )
    }    
    render() {
        return this.renderContent();
    }    
}

export default Rad